import { Suspense, LazyExoticComponent } from 'react';

type LazyComponentProps = {
  AsyncComponent:LazyExoticComponent<() => JSX.Element>;
};

function LazyComponent(props:LazyComponentProps) {
  const { AsyncComponent } = props;
  return (
    <Suspense fallback={<div>loading</div>}>
      <AsyncComponent />
    </Suspense>
  );
}

export default LazyComponent;
